<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableApproveSettingAreaAccounting"
    >
      <approve-list-setting
        :loading="isMainLoading"
        @onInit="getApproveTasksByMarket"
        subType="area_accounting_product"
        :approveTasks="approveTasks"
      ></approve-list-setting>
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveListSetting from "../../components/ApproveListSetting.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveListSetting,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    approveTasks() {
      return this.$store.getters["approveTask/getBySubType"](
        "area_accounting_product"
      );
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket", "area_accounting_product");
    }
  }
};
</script>

<style>
</style>